import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { AdaptedAlarmNotificationProfile } from 'data/alarmNotificationProfile/alarmNotificationProfile.types';

export enum AlarmNotificationProfileMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newAlarmNotificationProfile: AdaptedAlarmNotificationProfile = {
  alarmNtfyProfileId: '',
  name: '',
  email: [],
  profile_type: 'ALARM_INSTANCE', // default
  frequency: '',
  alarmsDef: [],
  alarmsInst: [],
  interceptAlarm: [],
  last_mailing_time: '',
};

export const alarmNotificationProfileColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('alarmNotificationProfile.grid.name'),
    field: 'name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'id',
    flex: 1,
    minWidth: 165,
  },
  {
    headerName: i18n.t('alarmNotificationProfile.grid.contentType'),
    field: 'profile_type',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'profile type',
    flex: 1,
    minWidth: 165,
    valueGetter: (p) => {
      const profileMap = {
        ALARM_DEFINITION: 'Alarm Definition',
        ALARM_INSTANCE: 'Alarm Instance',
        INTERCEPT_ALARM: 'Intercept Alarm'
      }
      const profileTypeValue = p.data.profile_type
      if (profileTypeValue in profileMap) {
        return profileMap[profileTypeValue as keyof typeof profileMap];
      }
      return '';
    }
  },
];
